import { Icon, iconName } from "assets/Icon";
import type { IconName } from "assets/ImportedIcons";
import {
	DropdownItem,
	DropdownMenu,
	DropdownMenuDrawer,
	DropdownMenuTrigger,
	MenuDivider,
} from "components/RFQ/MenuDropdown";
import type { Template } from "types/template";

type TemplateActionsButtonProps = {
	template: Template;
	templateId: number;
	onArchive: () => void;
	onDelete: () => void;
	onEdit: () => void;
	onLock: () => void;
};

interface MenuItem {
	name: string;
	divider?: boolean;
	icon: IconName; // or a specific type if you know the icon component type
	isTrash?: boolean | undefined;
	show: boolean;
	action: () => void; // handle click
}

const TemplateActionsButton = ({
	templateId,
	template,
	onEdit,
	onLock,
	onArchive,
	onDelete,
}: TemplateActionsButtonProps) => {
	const isLocked = template.status === "locked";
	const isArchived = template.status === "archived";
	const canDelete = template.status !== "locked";

	const menuItems: MenuItem[] = [
		{
			name: "Edit Template",
			icon: iconName("edit"),
			action: onEdit,
			divider: false,
			show: !isLocked,
		},
		{
			name: isLocked ? "Active Template" : "Lock Template",
			icon: iconName(isLocked ? "template" : "lock"),
			action: onLock,
			divider: false,
			show: true,
		},
		{
			name: isArchived ? "Active Template" : "Archive Template",
			icon: iconName(isArchived ? "template" : "archive"),
			action: onArchive,
			divider: true,
			show: true,
		},
		{
			name: "Delete Template",
			icon: iconName("trash-03"),
			action: onDelete,
			divider: false,
			show: canDelete,
			isTrash: true,
		},
	].filter((item) => item.show);

	return (
		<div>
			<DropdownMenu className="flex justify-end">
				<DropdownMenuTrigger icon>
					<div />
				</DropdownMenuTrigger>
				<DropdownMenuDrawer>
					{menuItems.map((menu, index) => (
						<div key={index}>
							<DropdownItem
								className="w-full cursor-pointer"
								onClick={menu.action}
							>
								<Icon
									icon={menu.icon}
									width={16}
									height={16}
									style={{
										color: menu.isTrash ? "#EF4444" : "#344054",
									}}
								/>
								<p
									className={`font-roboto text-[14px] font-medium hover:text-[14px] ${
										menu.isTrash ? "text-red-600" : "text-secondary-700"
									}`}
									style={{ lineHeight: "20px" }}
								>
									{menu.name}
								</p>
							</DropdownItem>
							{menu.divider && <MenuDivider />}
						</div>
					))}
				</DropdownMenuDrawer>
			</DropdownMenu>
		</div>
	);
};

export default TemplateActionsButton;
